import React, { useState } from "react";
import ILC_From from "./ilc_From/ILC_From";
import ILC_table from "./ilc_table/ILC_table";

function ILC() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <ILC_From onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <ILC_table/>
        </div>
      )}
    </>
  );
}

export default ILC;
